/** What the page posts to a waiting service worker when the reader asks for the new version. */
export const SKIP_WAITING_MESSAGE = 'skip-waiting';
